import { render, staticRenderFns } from "./pageDetail.vue?vue&type=template&id=28c82d76&scoped=true&"
import script from "./pageDetail.vue?vue&type=script&lang=js&"
export * from "./pageDetail.vue?vue&type=script&lang=js&"
import style0 from "./pageDetail.vue?vue&type=style&index=0&id=28c82d76&scoped=true&lang=scss&"
import style1 from "./pageDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c82d76",
  null
  
)

export default component.exports